import {HttpController} from './http_config.controller';

function httpConfig($stateProvider) {
	$stateProvider
		.state('settings.httpConfig', {
			url: '/http_settings',
			template: require('./http_config.html'),
			controller: 'HttpController as HttpCtrl',
			params: {
				title: 'HTTP Settings'
			}
		});
}

export default angular.module('httpConfig', [])
                      .config(httpConfig)
                      .controller('HttpController', HttpController);



// WEBPACK FOOTER //
// ./modules/xray/states/settings/tabs/http_config/http_config.module.js